import React from 'react';
import { Link } from 'react-router-dom';
import MediaAndContentLarge from '../Cards/MediaAndContentLarge';
import MediaAndContentMini from '../Cards/MediaAndContentMini';
import { IMediaAndContent } from '../../interfaces/MediaAndContent';

type CardVariant = 'default' | 'brand';
interface IMediaAndContentMapper {
    data: IMediaAndContent[] | null;
    viewType: 'mini' | 'large';
    subPath?: string;
    variant?: CardVariant;
    disableScroll?: boolean;
    spacer?: boolean;
}

const MediaAndContentMapper = ({ data, viewType, subPath = 'actividades', variant = 'default', disableScroll = false, spacer = false }: IMediaAndContentMapper) => {
    const renderContent = (renderContent: IMediaAndContent) => {
        const renderContentKey = renderContent.titulo.replaceAll(" ", '-').replaceAll(':', '').toLowerCase();
        // Generamos la URL para el enlace dependiendo del tipo de visualización
        const renderContentLink = viewType === 'large' ?
            `${encodeURIComponent(renderContentKey)}-id${renderContent.id}` :  // URL para la vista grande
            `/monitor/${subPath}/${encodeURIComponent(renderContentKey)}-id${renderContent.id}`; // URL para la vista mini

        return (
            <div className={viewType === 'large' ? 'mb-8' : 'flex gap-6'} key={renderContent.id}>
                <Link to={renderContentLink} state={{ id: `${Number(renderContent.id)}` }}>
                    {viewType === 'large' ? (
                        // Si la vista es grande, renderizamos MediaAndContentLarge
                        <MediaAndContentLarge
                            key={renderContent.id}
                            id={renderContent.id}
                            imagen={renderContent.imagen}
                            titulo={renderContent.titulo}
                            categorias={renderContent.categorias}
                            descripcion={renderContent.descripcion}
                            fecha={renderContent.fecha}
                        />
                    ) : (
                        // Si la vista es mini, renderizamos MediaAndContentMini
                        <MediaAndContentMini
                            key={renderContent.id}
                            id={renderContent.id}
                            imagen={renderContent.imagen}
                            titulo={renderContent.titulo}
                            descripcion={renderContent.descripcion}
                            fecha={renderContent.fecha}
                            categorias={renderContent.categorias}
                            variant={variant}
                        />
                    )}
                </Link>
            </div>
        );
    };

    return (
        <div className={viewType === 'large' ? 'mt-12' : `${!disableScroll ? 'lg:max-xl:w-[55rem] xl:w-[70.5rem] overflow-x-auto pb-4 xl:pb-0' : ''}`}>
            {viewType === 'large' ? (
                data?.map(renderContent)
            ) : (
                <div className="flex">
                    {data?.map((item, index, arr) => (
                        <div
                            key={item.id}
                            className={spacer && index !== arr.length - 1 ? 'mr-6' : ''}
                        >
                            {renderContent(item)}
                        </div>
                    ))}
                    {spacer && <div className="w-[calc((100vw-20.5rem)/2)] sm:w-[calc((100vw-33.5rem)/2)] md:hidden flex-shrink-0" />}
                </div>
            )}
        </div>
    );
};

export default MediaAndContentMapper;
// Componente para mapear una lista de datos a diferentes tipos de visualización, por ejemplo las cards de actividades e informes y acciones